// // remap jQuery to $.
(function($) {

	// trigger when page is ready.
	$(document).ready(
		function() {
// Landing page: Selected Posts Slider - depends on Slick.js - http://kenwheeler.github.io/slick/
			landingPostsSlick();

			function landingPostsSlick()
			{
				const landing_posts_slider = $('.landing-posts-slider');
				landing_posts_slider.slick(
					{
						appendDots: $('.landing-posts-footer'),
						arrows: false,
						autoplay: false,
						dots: true,
						draggable: true,
						infinite: true,
						// lazyLoad: 'progressive',
						// mobileFirst: true,
						// nextArrow: $('.landing-posts-slick-next'),
						// prevArrow: $('.landing-posts-slick-prev'),
						responsive: [
							{
								breakpoint: 600,
								settings: {
									slidesToShow: 1,
									slidesToScroll: 1,
									// variableWidth: true,
								}
							},
							{
								breakpoint: 1000,
								settings: {
									slidesToShow: 2,
									slidesToScroll: 1,
									// variableWidth: true,
								}
							},
							{
								breakpoint: 1200,
								settings: {
									slidesToShow: 3,
									slidesToScroll: 1,
									// variableWidth: true,
								}
							},
						],
						slidesToShow: 4,
						slidesToScroll: 1,
						speed: 700,
						touchThreshold: 10,
						// variableWidth: true,

					}
				);
				$('body').on('click', '.landing-posts-block .slick-dot', function() {
					landing_posts_slider.addClass('sliding');
					landing_posts_slider.on(
						'afterChange',
						function() {
							$(this).removeClass('sliding');
						}
					);
				})
				landing_posts_slider.on(
					'mousedown',
					function() {
						$(this).addClass('sliding');
					}
				);
				landing_posts_slider.on(
					'afterChange mouseup',
					function() {
						$(this).removeClass('sliding');
					}
				);
			}

			// Initialize dynamic block preview (editor).
			if (window.acf) {
				window.acf.addAction('render_block_preview/type=landing-posts', landingPostsSlick);
			}


			// 			function initializeCardBlock()
			// {
			// 	$('.call-out-card-block').attr('style', 'background-color: red');
			// }
			//
			// initializeCardBlock();
			//
			// // Initialize dynamic block preview (editor).
			// if (window.acf) {
			// 	window.acf.addAction('render_block_preview/type=call-out-card', initializeCardBlock);
			// }


		})

})(window.jQuery);
